/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ImageFontNode", ["NodeBase", "NodeFactory"], function (context, cls) {
  /**
   * @class ImageFontNode
   * @memberOf classes
   * @extends classes.NodeBase
   */
  class ImageFontNode extends cls.NodeBase /** @lends classes.ImageFontNode.prototype */ {
    constructor(parent, tag, id, attributes, app) {
      super(parent, tag, id, attributes, app);

      let fontFileTransferUrl = this.attribute("href");

      // Rewrite URL to use Vite proxy instead
      if (gbc.buildTool === "vite") {
        const devServerPort = import.meta.env.VITE_PORT || location.port;
        const gasPort = import.meta.env.GAS_PORT || 6394;
        fontFileTransferUrl = fontFileTransferUrl.replace(`${gasPort}`, devServerPort);
      }

      const ttfFile = context.__wrapper.wrapResourcePath(fontFileTransferUrl, null, this.getApplication().info().nativeResourcePrefix);
      this._ttfName = "image2font_" + this.attribute("name").replaceAll(".ttf", "");
      this._stylesheetId = this._ttfName.replaceAll(" ", "_") + this.getApplication().info().session + this.getApplication().applicationHash;
      const styleRules = {
        "@font-face": {
          "font-family": '"' + this._ttfName.trim() + '"',
          src: "url('" + ttfFile + "')"
        }
      };
      context.styler.appendStyleSheet(styleRules, this._stylesheetId, true);
    }
    destroy() {
      context.styler.removeStyleSheet(this._stylesheetId);
      super.destroy();
    }
  }
  cls.ImageFontNode = ImageFontNode;
  cls.NodeFactory.register("ImageFont", cls.ImageFontNode);
});
